<!--
  Props
    tracks
  Events
    track_change
-->
<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex xs11 md11>
        <v-form>
          <v-expansion-panel v-model="panel" expand>
            <v-expansion-panel-content
              v-for="(faixa, index) in faixas"
              :key="faixa.row_count"
              :class="{'blue lighten-5': index % 2 !== 0,  'grey lighten-5': index %2 == 0}"
            >
              <template v-slot:actions>
                <v-icon color="primary">$vuetify.icons.expand</v-icon>
              </template>
              <template v-slot:header>
                <div>
                  <strong style="color:#000">
                    {{index + 1}}
                    <template v-if="faixa.name"> - {{faixa.name}}</template>
                    <template v-if="faixa.isrc"> - {{faixa.isrc}}</template>
                  </strong>
                </div>
              </template>

              <v-divider></v-divider>

              <v-layout wrap class="white" mx-0 mb-0>
                <v-flex xs12 md8>
                  <v-text-field
                    v-model="faixa.name"
                    class="purple-input"
                    label="Nome da faixa"
                    data-vv-name="name"
                    :data-vv-id="faixa.row_count"
                    messages="Nome que será utilizado para todas as plataformas parceiras."
                    v-validate="'required'"
                    :error-messages="errors.collect('name')"
                  />
                </v-flex>
                <v-flex xs12 md3>
                  <v-text-field
                    v-model="faixa.isrc"
                    class="purple-input"
                    label="ISRC"
                    messages="Registro da obra, se não tiver geraremos uma para você."
                  />
                </v-flex>

                <v-flex xs12 md1 v-if=" index >= 0">
                  <v-btn fab dark small color="error" @click="remove_faixa(faixa.id)">
                    <v-icon dark>remove</v-icon>
                  </v-btn>
                </v-flex>

                <v-flex xs12 md6>
                  <v-combobox
                    v-model="faixa.works"
                    :items="obras"
                    label="Obras da faixa"
                    item-text="name"
                    item-value="id"
                    chips
                    clearable
                    multiple
                    messages="Vincule as suas obras ou as obras a qual você tem direito de uso. Entenda o por quê <a hre='#!'>aqui</a>."
                    v-validate="'required'"
                    data-vv-name="obras"
                    :error-messages="errors.collect('obras')"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :selected="data.selected"
                        close
                        @input="removeObra(faixa, data.item.name)"
                      >
                        <strong>{{ data.item.name }}</strong>&nbsp;
                        <!--span>(
                            <template v-for="_composer in data.item.composers">{{_composer.name}} </template>
                        )</span-->
                      </v-chip>
                    </template>
                  </v-combobox>
                </v-flex>

                <v-flex xs12 md6>
                  <v-list
                    subheader
                    three-line
                    style="border:1px solid grey;"
                    v-if="faixa.works && faixa.works.length > 0"
                  >
                    <v-subheader style="background-color:#037ac4" dark>OBRAS DO FONOGRAMA</v-subheader>
                    <v-divider />
                    <v-radio-group
                      v-model="faixa.tipo"
                      style="padding-left:15px;margin-bottom:5px"
                      v-if="faixa.works.length && faixa.works.length > 1"
                      row
                      label="Tipo de fonograma"
                      messages="Em fonogramas com mais de uma obra é necessário explicitar o tipo de fonograma"
                      required
                    >
                      <v-radio label="Incidental" value="incidental"></v-radio>
                      <v-radio label="Pout-porri" value="poutporri"></v-radio>
                    </v-radio-group>
                    <v-divider />
                    <v-list-group v-for="obra in faixa.works" :key="obra.id" no-action>
                      <template v-slot:activator>
                        <v-list-tile ripple>
                          <v-list-tile-action>
                            <v-icon>waves</v-icon>
                          </v-list-tile-action>

                          <v-list-tile-content>
                            <v-list-tile-title>{{ obra.name }}</v-list-tile-title>
                          </v-list-tile-content>

                          <v-list-tile-action>
                            <v-text-field
                              v-model="obra.track_share"
                              label="Percentual"
                              required
                              v-if="faixa.works && faixa.works.length > 1"
                            ></v-text-field>
                          </v-list-tile-action>
                        </v-list-tile>
                      </template>

                      <v-list-tile v-for="compositor in obra.composers" :key="compositor.id">
                        <v-list-tile-action>
                          <v-icon>face</v-icon>
                        </v-list-tile-action>

                        <v-list-tile-content>
                          <v-list-tile-title>{{ compositor.name }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-divider />
                    </v-list-group>
                  </v-list>
                </v-flex>
                <v-flex xs12>
                  <v-divider />
                </v-flex>

                <v-flex xs12 md6>
                  <v-combobox
                    v-model="faixa.artists"
                    :items="artistas"
                    item-value="id"
                    item-text="name"
                    label="Artistas da Faixa"
                    chips
                    clearable
                    multiple
                    messages="Selecione os artistas dessa faixa."
                    v-validate="'required'"
                    data-vv-name="artistas"
                    :error-messages="errors.collect('artistas')"
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        :selected="data.selected"
                        close
                        @input="removeArtista(faixa,data.item)"
                      >
                        <strong>{{ data.item.name }}</strong>&nbsp;
                        <!--span>(MK Music)</span-->
                      </v-chip>
                    </template>
                  </v-combobox>
                </v-flex>

                <v-flex xs12 md6>
                  <v-list
                    subheader
                    three-line
                    style="border:1px solid grey;"
                    v-if="faixa.artists && faixa.artists.length>0"
                  >
                    <v-subheader
                      style="background-color:#037ac4"
                      dark
                    >ARTISTAS DA FAIXA (ordem de importância para a faixa)</v-subheader>
                    <v-divider />
                    <v-checkbox
                      style="padding-left:15px;margin-bottom:5px"
                      v-if="faixa.artists && faixa.artists.length>1"
                      v-model="faixa.collab"
                      label="COLLAB"
                      messages="Habilita este produto na página de lançamento dos artistas dessa faixa."
                    ></v-checkbox>

                    <v-divider />
                    <draggable
                      v-model="faixa.artists"
                      group="people"
                      @start="drag=true"
                      @end="drag=false"
                    >
                      <v-list-tile v-for="_artista in faixa.artists" :key="_artista.id">
                        <v-list-tile-action style="cursor:pointer" class="list-group-item">
                          <v-icon>reorder</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>{{_artista.name}}</v-list-tile-title>
                          <!--v-list-tile-sub-title>blablabla</v-list-tile-sub-title-->
                        </v-list-tile-content>
                        <v-list-tile-action></v-list-tile-action>
                      </v-list-tile>
                    </draggable>
                  </v-list>
                </v-flex>

                <v-flex xs2 md2 v-if="faixa.artists && faixa.artists.length >1"></v-flex>
              </v-layout>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-form>
      </v-flex>
      <v-flex xs1 md1 right>
        <v-btn fab dark color="indigo" @click="add_faixa">
          <v-icon dark>add</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import draggable from "vuedraggable";
import Vue from "vue";
import VeeValidate from "vee-validate";
import { mapGetters } from "vuex";

Vue.use(VeeValidate);

export default {
  $_veeValidate: {
    validator: "new"
  },
  props: {
    tracks: Array
  },
  data() {
    return {
      count_faixas: 1,
      //artistas_selecionados: [],
      //obras_selecionadas: [],
      panel: [true],
      faixas: [{ row_count: 0, expanded: true, works: [], artists: [] }],
      select: null,
      //obras: [],
      //validador
      dictionary: {
        attributes: {
          name: "E-mail Address"
        },
        custom: {
          name: {
            required: "O nome da faixa não pode estar vazio"
          },
          obras: {
            required:
              "É obrigatório ao menos uma obra para compor um fonograma."
          },
          artistas: {
            required: "É necessário ao menos um artista nessa faixa."
          }
        }
      }
    };
  },
  components: {
    draggable
  }, 
  watch: {
    /**
     * Dispara o evento sempre que há uma mudança em alguma informação das faixas
     */
    faixas: {
      handler: function(e) {
        this.$emit("track_change", this.faixas);
        //this.tracks = this.faixas;
      },
      deep: true
    }
  },
  //--------------------------
  //RENDER EVENTS
  //--------------------------
  created: function() {
    if (this.tracks.length == 0) {
      return;
    }
    this.faixas = this.tracks;
  },
  beforeUpdate: function() {
    console.log("beforeUpdate", this.tracks);
    if (this.tracks.length == 0) {
      return;      
    } else {
      this.faixas = this.tracks;
    }
  },
  beforeMount: function() {   
    this.$validator.localize("pt_br", this.dictionary);
  },
  //--------------------------
  //COMPUTED PROPERTIES
  //--------------------------
  computed: {
    ...mapGetters(["obras", "artistas"])
  },
  //--------------------------
  //METHODS
  //--------------------------
  methods: {
    removeObra(faixa, item) {
      faixa.works.splice(faixa.works.indexOf(item), 1);
      faixa.works = [...faixa.works];
      //this.obras.push(item);
    },
    removeArtista(faixa, item) {
      faixa.artists.splice(faixa.artists.indexOf(item), 1);
      faixa.artists = [...faixa.artists];
      //this.artistas.push(item);
    },
    add_faixa: function() {
      this.count_faixas = this.count_faixas + 1;

      this.faixas.push({
        row_count: this.count_faixas,
        nome: null,
        works: [],
        artists: [],
        isrc: null
      });
    },
    remove_faixa: function(indice) {
      var t_faixas = [];
      this.faixas.forEach(element => {
        if (indice != element.id) {
          t_faixas.push(element);
        }
      });
      this.faixas = t_faixas;
      this.count_faixas = this.count_faixas - 1;
    },

    submit: function() {
      return this.$validator.validateAll();
    }
  }
};
</script>

<style>
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
</style>